(ns pfo.widget.orgchart
  (:require [reagent.core :as reagent :refer [atom track!] :refer-macros [with-let]]
            [promesa.core :as p]
            [cljs-uuid-utils.core :as uuid]
            ["cytoscape" :as cytoscape]
            [pfo.util :as util :refer [to-clj]]
            [pfo.revroutes :refer [path-for]]
            [pfo.coltype.model :as coltype-model]
            [pfo.state :as state]
            [pfo.coltype.components.details :as coltype-details :refer [field-types string-field filter-fields]]
            [pfo.controller :as controller :refer [subscribe]]
            [pfo.common.component :as common]
            [pfo.api :as api :refer [process-error]]
            [pfo.collection.model :as collection-model]
            [clojure.set :as set]
            [pfo.form :as form]))

(def max-assets-in-row 5)
(def chart-base-height "900px")
(def include-legend false)

(def filtered-menu-members-selector "[type = 'filtered_menu_members']")
(def filtered-menu-roles-left-selector "[type = 'filtered_menu_roles_left']")
(def filtered-menu-roles-right-selector "[type = 'filtered_menu_roles_right']")
(def filtered-menu-selector (str filtered-menu-members-selector ", " filtered-menu-roles-left-selector, ", " filtered-menu-roles-right-selector))
(def sum-members-selector "[type = 'sum_members']")
(def sum-roles-left-selector "[type = 'sum_roles'][position_subject_relative = 'left']")
(def sum-roles-right-selector "[type = 'sum_roles'][position_subject_relative = 'right']")
(def filter-node-members-selector "[id = 'filter-node-members']")
(def filter-node-roles-left-selector "[id = 'filter-node-roles-left']")
(def filter-node-roles-right-selector "[id = 'filter-node-roles-right']")

(def style
  [{:selector "node"
    :style {:content "data(label)"
            :text-valign "center"
            :text-halign "center"
            :width "label"
            :height "label"
            :shape "round-rectangle"
            :text-wrap "wrap"
            :text-max-width "95%"
            :padding "5px"  
            :color "#1E3C60"
            :font-size "11px"
            :border-width 2
            :background-color "lightblue"}}

   {:selector "node[type = 'header']"
    :style {:width "150px"
            ;; :height "60px"
            :background-color "white"
            :border-width "0"
            :font-size "12px"
            :font-weight "bold"
            :text-valign "left"
            :text-halign "top"
            :color "#1D3A5F"}}

   {:selector "node[type = 'subject']"
    :style {:background-color "#1B385E"
            :border-color "#3773c1"
            :shape "round-rectangle"
            :width "150px"
            :height "100px"
            :color "#fff"
            :font-size "14px"}}

   {:selector "node[type = 'entity']"
    :style {:shape "diamond"
            :width "100px"
            :height "100px"
            :border-color "#92d1db"
            :text-max-width "85%"
            :background-color "#DEF1F4"}}

   {:selector "node[type = 'individual']"
    :style {:width "120px"
            :height "40px"
            :border-color "#3e9c82"
            :background-color "#77C9B2"}}
   
   {:selector "node[type = 'liability']"
    :style {:width "120px"
            :height "40px"
            :border-color "#eded0d"
            :background-color "#FCFCCA"}}

   {:selector "node[type = 'asset']"
    :style {:width "120px"
            :height "40px"
            :background-color "#DEF1F4"
            :border-color "#92d1db"
            :shape "rectangle"}}

   {:selector "node[type = 'role']"
    :style {:width "170px"
            :height "22px"
            :text-max-width "170px"
            :border-color "#bf7c00"
            :background-color "orange"}}
   
   {:selector "node[type = 'legend']"
    :style {:width "180px"
            :height "220px"
            :background-color "white"
            :background-image  "url('/static/img/bg/chart-diagram-key.png')"
            :background-width "100%"
            :background-height "100%"
            :background-repeat "no-repeat"
            :border-width "1"
            :border-color "lightgray"}}
   
   {:selector filtered-menu-members-selector
    :style {:width "170px"
            :height "22px"
            :text-max-width "170px"
            :border-color "#3e9c82"
            :background-color "#77C9B2"}}
   
   {:selector filter-node-members-selector
    :style {:width "170px"
            :height "22px"
            :text-max-width "170px"
            :background-color "#77C9B2"
            :background-image  "url('/static/img/icons/search.png')"
            :background-width "13px"
            :background-height "13px"
            :background-position-x "10px",
            :background-repeat "no-repeat"}}
   
   {:selector sum-members-selector
    :style {:width "150px"
            :height "22px"
            :text-max-width "195px"
            :border-color "#3e9c82"
            :background-color "#77C9B2"}}
   
   {:selector (str filter-node-roles-left-selector ", " filter-node-roles-right-selector)
    :style {:width "200px"
            :height "22px"
            :text-max-width "195px"
            :background-color "orange"
            :background-image  "url('/static/img/icons/search.png')"
            :background-width "13px"
            :background-height "13px"
            :background-position-x "10px",
            :background-repeat "no-repeat"}}
   
   {:selector (str filtered-menu-roles-left-selector ", " filtered-menu-roles-right-selector)
    :style {:width "200px"
            :height "22px"
            :border-color "#bf7c00"
            :text-max-width "195px"
            :background-color "orange"}}
   
   {:selector "node[type = 'sum_roles']"
    :style {:width "150px"
            :height "22px"
            :text-max-width "195px"
            :border-color "#bf7c00"
            :background-color "orange"}}
   
   {:selector ".brightened-orange"
    :style {:background-color "#FFCC80"}}
   
   {:selector ".brightened-green"
    :style {:background-color "#B0E4D0"}}

   {:selector "edge"
    :style {:width 2
            :arrow-scale 0.8
            :curve-style "round-taxi"
            :taxi-direction "vertical"
            :label "data(arrow)"
            :target-label "data(target_label)"
            :source-label "data(source_label)"
            :source-text-offset 25
            :target-text-offset 18
            :text-margin-y -8
            :text-rotation "autorotate"
            :font-size 10
            :line-color "#bbbbbb"
            :color "#1B385E"}}

   {:selector "edge[direction = 'target']"
    :style {:target-arrow-color "#333"
            :target-arrow-shape "triangle"
            :target-arrow-fill "filled"}}

   {:selector "edge[direction = 'source']"
    :style {:source-arrow-color "#333"
            :source-arrow-shape "triangle"
            :source-arrow-fill "filled"}}

   {:selector "edge[direction = 'two-way']"
    :style {:target-arrow-color "#333"
            :target-arrow-shape "triangle"
            :target-arrow-fill "filled"
            :source-arrow-color "#333"}}])

(def items-render-type-menu "menu")
(def items-render-type-down "down")
(def items-render-type-center "center")
(def chart-type-wealth-map "wealth_map")
(def chart-type-cta "cta")
(def chart-type
  {chart-type-wealth-map "Wealth Map"
   chart-type-cta "CTA Beneficial Ownership"})

(defn node-controls [display {x :x y :y} offset-by-ratio component]
  [:div.c-chart-node-control
   {:ref (fn [el]
           (when el
             (let [width (.-width (.getBoundingClientRect el))]
               (aset el "style" "position" "absolute")
               (aset el "style" "cursor" "pointer")
               (aset el "style" "left" (str (+ x (* width (or (:width offset-by-ratio) 0))) "px"))
               (aset el "style" "top" (str (+ y (* width (or (:height offset-by-ratio) 0))) "px")))))}
   (when display component)])

(defn left-node-controls [options subject-collection-id node-data display position offset-by-ratio]
  [node-controls display position offset-by-ratio
   (let [node-object-id (-> node-data :object :id)]
     (when (and
           (= "col" (:object_type node-data))
           (collection-model/can-be-chart-subject? (:object node-data))
           ;; Don't display chart icon for the subject of the chart
           (not= node-object-id subject-collection-id)
           (:permitted_collection_chart node-data))
     [:a.c-nav-chart (merge options {:href (when node-object-id (path-for :collection-charts :id node-object-id))})]))])

(defn- node-url [node-data]
  (when (:permitted node-data)
    (when-let [col-id (-> node-data :object :id)]  (path-for :collection-details :id col-id))))

(defn right-node-controls [options subject-collection-id node-data display position offset-by-ratio]
  [node-controls display position offset-by-ratio
   (when (and
           (= "col" (:object_type node-data))
           (collection-model/can-be-chart-subject? (:object node-data))
           ;; Don't display workspace icon for the subject of the chart
           (not= (-> node-data :object :id) subject-collection-id)
           (:permitted node-data))
     [:a.c-nav-collection (merge options {:href (node-url node-data)
                                          :target "_blank"})])])

(def resize-listener (atom nil))
(defn- add-resize-listener [listener]
  (when @resize-listener
    (.removeEventListener js/window "resize" @resize-listener))
  (reset! resize-listener listener)
  (.addEventListener js/window "resize" listener))

(defn- remove-resize-listener []
  (when @resize-listener
    (.removeEventListener js/window "resize" @resize-listener)
    (reset! resize-listener nil)))

(defn- is-filtered-node-type [node-type]
  (contains? #{"filtered_menu_members" "filtered_menu_roles_left" "filtered_menu_roles_right"} node-type))

(defn- is-filtered-node [node] (is-filtered-node-type (.data node "type")))

(defn cytoscape-component [chart-data notify-modified! view-reset-atom]
  (let [element (atom nil)
        input-element (atom nil)
        input-element-state (atom {:display false})
        cy-instance (atom nil)
        last-chart-data (atom chart-data)

        notify? (clojure.core/atom true)
        dont-notify (fn [no-arg-func]
                      (reset! notify? false)
                      (no-arg-func)
                      (reset! notify? true))
        notify-modified! (fn []
                           (when @notify?
                             (notify-modified!)))
        filtered-members (atom nil)
        filtered-members-visible (atom false)
        filtered-roles-right (atom nil)
        filtered-roles-right-visible (atom false)
        filtered-roles-left (atom nil)
        filtered-roles-left-visible (atom false)
        container-rect (atom nil)

        render-down-items (fn [parent-node items]
                            (let [down-nodes (.nodes @cy-instance (str "[top-node = '" (.id parent-node) "']"))]
                              (.remove down-nodes))
                            (doseq [[index item] (map-indexed vector items)
                                    :let [item (to-clj item)]]
                              (let [parent-type (.data parent-node "type")]
                                (.add @cy-instance
                                      (clj->js {:group "nodes"
                                                :grabbable false
                                                :data (merge
                                                       (select-keys item [:id :label :url :object :object_type :object_id :permitted :permitted_collection_chart
                                                                          :aggregation_count :aggregation_label])
                                                       {:top-node (.id parent-node)
                                                        :type parent-type})
                                                :position {:x (.position parent-node "x")
                                                           :y (+ (.position parent-node "y")
                                                                 (* (inc index) (.-h (.boundingBox parent-node))))}})))))

        render-center-items (fn [parent-node]
                              (let [offset-step (.-h (.boundingBox parent-node))
                                    initial-y (.position parent-node "y")]
                                (doseq [[index item] (map-indexed vector (.data parent-node "items"))
                                        :let [item (to-clj item)]]
                                  (let [parent-type (.data parent-node "type")
                                        is-above (zero? (mod index 2))
                                        new-y (if is-above
                                                (- initial-y (* (inc (quot index 2)) offset-step))
                                                (+ initial-y (* (inc (quot index 2)) offset-step)))]
                                    (.add @cy-instance
                                          (clj->js {:group "nodes"
                                                    :grabbable false
                                                    :data  (merge
                                                            (select-keys item [:id :label :url :object :object_type :object_id :permitted :permitted_collection_chart])
                                                            {:type parent-type})
                                                    :position {:x (.position parent-node "x")
                                                               :y new-y}}))))))
        node-controls-state (atom {:display false
                                   :left-position {:x 0 :y 0}
                                   :right-position {:x 0 :y 0}})
        node-controls-hide-timeout (clojure.core/atom nil)
        node-controls-mouse-over (fn []
                                   (when @node-controls-hide-timeout
                                     (js/clearTimeout @node-controls-hide-timeout)))
        node-controls-mouse-out (fn []
                                  (node-controls-mouse-over)
                                  (reset! node-controls-hide-timeout
                                          (js/setTimeout
                                           (fn []
                                             (reset! node-controls-state {:display false})) 1000)))
        node-controls-options {:on-mouse-over node-controls-mouse-over
                               :on-mouse-out node-controls-mouse-out}
        render-items (fn []
                       (doseq [node (.nodes @cy-instance)]
                         (when (.data node "items")
                           (condp = (.data node "items_render_type")
                             items-render-type-down (when-not (is-filtered-node node) (render-down-items node (.data node "items")))
                             items-render-type-center (render-center-items node)
                             nil))))

        hide-menu-items (fn  [parent-node]
                          (.data parent-node "menuVisible" false)
                          (doseq [[index _] (map-indexed vector (.data parent-node "items"))]
                            (let [menu-item-id (str (.id parent-node) "-menu-" index)]
                              (.remove @cy-instance (clj->js (str "#" menu-item-id))))))

        show-menu-items (fn [parent-node]
                          (.data parent-node "menuVisible" true)
                          (doseq [[index item] (map-indexed vector (.data parent-node "items"))]
                            (let [menu-item-id (str (.id parent-node) "-menu-" index)
                                  x (.position parent-node "x")
                                  y (+ (.position parent-node "y")
                                       (.-h (.boundingBox parent-node))
                                       (* index (.-h (.boundingBox parent-node))))]
                              (.add @cy-instance (clj->js {:group "nodes"
                                                           :data  {:id menu-item-id
                                                                   :label (.-label item)
                                                                   :url (.-url item)
                                                                   :type (.data parent-node "type")}
                                                           :position {:x x :y y}})))))
        register-tap-ev (fn []
                          (.on @cy-instance "tap" "node"
                               (fn [evt]
                                 (let [node (.-target evt)
                                       url (node-url (to-clj (.data node)))]
                                   (cond
                                     url (js/window.open url "_blank")
                                     (and (.data node "items") (= (.data node "items_render_type") items-render-type-menu))
                                     (if (.data node "menuVisible")
                                       (hide-menu-items node)
                                       (show-menu-items node)))))))
        cols-number (fn [chart-data]
                      (let [cols (if include-legend
                                   4
                                   (+ 2 (max (count (filter #(= "entity" (:type %)) (:nodes chart-data)))
                                          (count (filter #(= (or "asset" "liability" "investment_fund") (:type %)) (:nodes chart-data))))))]
                        (if (< cols 3) 3 cols)))
        position (fn [chart-data]
                   (let [node-sets [#{"header"}
                                    #{"entity"}
                                    #{"individual"}
                                    #{"subject" "role"}
                                    #{"asset" "liability" "investment_fund"}]
                         cols-num (cols-number chart-data)
                         node-alignments [#{#{"entity"} #{"individual"}}]
                         nodes-grouped-by-type (into {} (group-by (fn [node]
                                                                    (first (filter #(contains? % (:type node)) node-sets)))
                                                                  (:nodes chart-data)))
                         group-node-max-index (fn [group]
                                                ;; There are groups that should be aligned together (see node-alignments)
                                                ;; The node count, later used to calculate "push" offset to the right offset,
                                                ;; considers the maximum node count value from those aligned together groups
                                                (let [alignment (or
                                                                  (first
                                                                    (filter
                                                                      (fn [node-alignment] (contains? node-alignment group))
                                                                      node-alignments))
                                                                  #{group})]
                                                  (dec (apply max (map #(count (nodes-grouped-by-type %)) alignment)))))
                         node-types-id-indexes (into {}
                                                     (apply
                                                      concat
                                                      (map
                                                       (fn [[group nodes]]
                                                         (let [max-group-index (group-node-max-index group)]
                                                           (map-indexed
                                                            (fn [index node]
                                                              [(:id node) {:index index
                                                                           :label (:label node)
                                                                           :max-index max-group-index}])
                                                            nodes)))
                                                       nodes-grouped-by-type)))
                         max-index (apply max (map :index (vals node-types-id-indexes)))
                         center-index (/ max-index 2)
                         has-right-roles (seq
                                           (filter
                                             (fn [node]
                                               (and
                                                 (or
                                                   (= "role" (:type node))
                                                   (= "sum_roles" (:type node)))
                                                 (= "right" (:position_subject_relative node))
                                                 (not (:placeholder node))))
                                             (:nodes chart-data)))
                         has-sum-roles (seq
                                           (filter
                                             (fn [node]
                                               (and
                                                 (= "sum_roles" (:type node))
                                                 (not (:placeholder node))))
                                             (:nodes chart-data)))
                         has-any-sum-nodes  (seq
                                              (filter
                                                (fn [node]
                                                  (and
                                                    (or
                                                      (= "sum_roles" (:type node))
                                                      (= "sum_members" (:type node)))
                                                    (not (:placeholder node))))
                                                (:nodes chart-data)))
                         has-sum-members (seq
                                           (filter
                                             (fn [node]
                                               (and
                                                 (= "sum_members" (:type node))
                                                 (not (:placeholder node))))
                                             (:nodes chart-data)))
                         filtered-items-base-col (+ center-index 1 (if has-right-roles 1 0))
                         asset-node-max-index (group-node-max-index #{"asset" "liability"})
                         filtered-items-col (if (> asset-node-max-index filtered-items-base-col) (inc asset-node-max-index) filtered-items-base-col)
                         asset-node-count (inc asset-node-max-index)]
                     (fn [node]
                       (let [indexes (node-types-id-indexes (.data node "id"))
                             offset (/ (- max-index (:max-index indexes)) 2)
                             original-col (.data node "col")
                             col (+ offset (:index indexes))
                             type (.data node "type")]
                         (clj->js
                           (let [{row :row col :col}
                                 (case type
                                   "header"     {:row 0   :col col}
                                   "entity"     {:row 0.5 :col (+ offset original-col)}
                                   "individual" {:row (if
                                                          (and
                                                            (= "top" (.data node "placeholder"))
                                                            (not has-any-sum-nodes))
                                                        2.5
                                                        1.2)


                                                 :col (if (and
                                                            (= "right" (.data node "placeholder"))
                                                            has-sum-members)
                                                        filtered-items-col
                                                        col)}
                                   "subject"    {:row 2.5   :col center-index}
                                   "role"       {:row 2.5   :col (case (.data node "position_subject_relative")
                                                                     "left" (dec center-index)
                                                                     (if (and (.data node "placeholder") has-sum-roles)
                                                                       filtered-items-col
                                                                       ;; (inc center-index)
                                                                       (inc center-index)))}
                                   "asset"      {:row 4   :col col}
                                   "liability"  {:row 4   :col col}
                                   "legend"  {:row (if (<= asset-node-count 5) 4.6 5.6)
                                              :col   (+ center-index
                                                       (get {0 0.5
                                                             1 1
                                                             2 1.4
                                                             3 1.8}
                                                         asset-node-count
                                                         2))}
                                   "sum_members"      {:row 1   :col center-index}
                                   "filtered_menu_members" {:row 1.2 :col filtered-items-col}
                                   "sum_roles"      {:row 2.5   :col (case (.data node "position_subject_relative")
                                                                     "left" (dec center-index)
                                                                     (inc center-index))}
                                   "filtered_menu_roles_left" {:row 1.2 :col filtered-items-col}
                                   "filtered_menu_roles_right" {:row 1.2 :col filtered-items-col}
                                   :default     {:row 1   :col col})]
                             ;; Scale the grid to affect node vs edge dimensions
                             {:row row :col (/ col (if (< cols-num 5) 1.5 1))}))))))
        truncate-label (fn [label]
                         (if (> (count label) 43)
                           (str (subs label 0 40) "...")
                           label))

        prepare-elements (fn [data]
                           (let [nodes (map (fn [node]
                                              (update node :label truncate-label))
                                            (:nodes data))
                                 edges (:edges data)]
                             {:nodes (map (fn [node-data]
                                            {:data node-data
                                             :grabbable false
                                             :style (merge
                                                      {:display (if (is-filtered-node-type (:type node-data))
                                                                  "none"
                                                                  "element")}
                                                      (:style node-data))})
                                          nodes)
                              :edges (map #(hash-map :data %) edges)}))

        init-cy (fn [chart-data]
                  (let [has-members (seq
                                       (filter
                                         (fn [node]
                                           (and
                                             (or
                                               (= "individual" (:type node))
                                               (= "sum_members" (:type node)))
                                             (not (:placeholder node))))
                                         (:nodes chart-data)))
                        has-sum-members (seq
                                      (filter
                                        (fn [node]
                                          (and
                                            (= "sum_members" (:type node))
                                            (not (:placeholder node))))
                                        (:nodes chart-data)))
                        chart-data (assoc chart-data :nodes
                                     (concat (:nodes chart-data)
                                       (filter identity
                                         [{:placeholder :right :label "right" :type "role" :style {:visibility :hidden} :hidden true}
                                          {:placeholder :left :label "left" :type "role" :position_subject_relative "left" :style {:visibility :hidden}}
                                          (when has-sum-members
                                            {:placeholder :right :label "invidivudal-right" :type "individual" :position_subject_relative "right" :style {:visibility :hidden}})
                                          (when-not has-members
                                            {:placeholder :top :label "top" :type "individual" :style {:visibility :hidden}})])))
                        cy (cytoscape (clj->js {:container @element
                                                :elements (prepare-elements chart-data)
                                                :style style
                                                :userZoomingEnabled (common/mobile?)
                                                :layout (merge
                                                          {:name "grid"
                                                           :cols (cols-number chart-data)
                                                           :rows 8
                                                           :spacingFactor 1
                                                           :position (position chart-data)}
                                                          (when include-legend
                                                            {:fit true
                                                             :padding 20
                                                             :spacingFactor  0.8
                                                             :rows 6}))}))
                        pan-offset (atom {:x 0 :y 0})
                        correct-pan! (fn []
                                       (let [pan (to-clj (.pan cy))
                                             zoom (to-clj (.zoom cy))
                                             zoom-negative-pan-threshold 0.7
                                             y (if (> (:y pan) 0) 0 (:y pan))
                                             y (if (< zoom zoom-negative-pan-threshold) 0 y)
                                             x (:x pan)]
                                         (reset! pan-offset {:x x :y y})
                                         (.pan cy (clj->js {:x x :y y}))))
                        show-controls-ev (fn [e]
                                           (let [node (.-target e)
                                                 pan (to-clj (.pan cy))
                                                 bb (to-clj (.boundingBox node))
                                                 page-position (fn [{x :x y :y}]
                                                                 {:x (+ (* x (.zoom cy)) (:x pan))
                                                                  :y (+ (* y (.zoom cy)) (:y pan))})]
                                             (node-controls-mouse-over)
                                             (reset! node-controls-state {:display true
                                                                          :node-data (to-clj (.data node))
                                                                          :left-position (page-position {:x (:x1 bb) :y (:y1 bb)})
                                                                          :right-position (page-position {:x (:x2 bb) :y (:y1 bb)})})))]

                    (-> cy .container (.addEventListener "wheel"
                                                         (fn [event]
                                                           (.preventDefault event)
                                                           (when (.-shiftKey event)                                                             
                                                             (let [zoom-factor 0.1
                                                                   delta (if (zero? (.-wheelDeltaY event)) (.-wheelDeltaX event) (- (.-wheelDeltaY event)))
                                                                   zoom-in (< delta 0)
                                                                   current-zoom (.zoom cy)
                                                                   adj-zoom-factor (* zoom-factor (/ (abs delta) 27))
                                                                   zoom-level (if zoom-in
                                                                                (+ current-zoom adj-zoom-factor)
                                                                                (- current-zoom adj-zoom-factor))
                                                                   mouse-pos #js {:x (.-clientX event)
                                                                 ;; Y mouse position is adjusted based on pan offset and zoom level to maintain
                                                                 ;; the zoom point while we control the panning (don't allow too much empty space)
                                                                                  :y (+ (/ (:y @pan-offset) zoom-level) (.-clientY event))}]
                                                               (when (< 0.2 zoom-level 2)
                                                                 (reset! node-controls-state {:display false})
                                                                 (.zoom cy #js {:level zoom-level
                                                                                :renderedPosition mouse-pos})
                                                                 (notify-modified!)
                                                                 (correct-pan!))))
                                                           
                                                           (when-not (.-shiftKey event) 
                                                             (let [delta (.-deltaY event)
                                                                   pan (to-clj (.pan cy))]
                                                               (.pan cy (clj->js {:x (:x pan) :y (- (:y pan) delta)})))))))
                    (.on cy "render"
                         (fn []
                           (reset! container-rect (.getBoundingClientRect @element))))

                    (.on cy "pan" (fn [& _]
                                    (notify-modified!)
                                    (reset! node-controls-state {:display false})))
                    (.on cy "mouseover" "node" show-controls-ev)
                    (.on cy "mouseout" "node" node-controls-mouse-out)
                    ;; Code below is a starting point to control dragging; kept here in case
                    ;; it is decided dragging is needed after all.
                    #_(.on cy "dragfree position" "node" ; Listen to the node with a specific id or attribute
                           (fn [evt]
                             (.log js/console "EVENT" (-> evt .-target .-_private))
                             #_(let [node (.target evt) ; The node that triggered the event
                                     pos (.position node) ; Get the current position of the node
                                     x (.-x pos)
                                     y (.-y pos)
                                     linked-node (.get cy "[target='B']") ; Select the linked node(s)
                                     offset {:x 50 :y -30}] ; Relative offset to maintain
                                 (when (not (empty? linked-node))
                                   (.position linked-node
                                              (clj->js {:x (+ x (:x offset)) :y (+ y (:y offset))}))))))
                    (when (common/mobile?)
                      (.on cy "taphold" "node" show-controls-ev))
                    cy))

        adjust-container-height! (fn [cy]
                                   (set! (.-height (.-style @element))
                                         (str (apply max
                                                     (map (fn [node]
                                                            (let [bb (to-clj (.boundingBox node))]
                                                              (* (.zoom cy) (:y2 bb))))
                                                          (.nodes cy))) "px")))
        adjust-initial-pan! (fn [cy]
                              (let [min-y (apply min (map
                                                       (fn [node] (:y1 (to-clj (.boundingBox node))))
                                                       (filter
                                                         (fn [node] (not= "none" (.style node "display")))
                                                         (.nodes cy))))]
                                (.pan cy (clj->js {:y (* (- min-y) (.zoom cy))}))))

        filter-items (fn [items filter-text]
                       (filter (fn [item]
                                 (when-let [label (.toLowerCase (.-label item))]
                                   (.includes label (.toLowerCase filter-text))))
                               items))

        filter-and-render (fn [filter-atom parent-node filter-text]
                            (let [all-items (.data parent-node "items")]
                              (reset! filter-atom (filter-items all-items filter-text))
                              (render-down-items parent-node @filter-atom)))

        zoom-rescale (fn [value] (* (.zoom @cy-instance) value))
        convert-position (fn [{x :x y :y}]
                           (let [pan (to-clj (.pan @cy-instance))]
                             {:x (+ (zoom-rescale x) (:x pan))
                              :y (+ (zoom-rescale y) (:y pan))}))
        filter-input-node-fn (atom (fn [] {}))

        update-input-text (fn [current-input-state new-text]
                            (let [current-filter-text (:filter-text current-input-state)
                                  type (:selector current-input-state)]
                              (merge current-input-state
                                {:filter-text (assoc current-filter-text type new-text)})))
        get-input-text #(get-in @input-element-state [:filter-text (:selector @input-element-state)])

        select-node (fn [selector] (first (.nodes @cy-instance selector)))

        add-filter-input (fn [filter-atom selector bg-color]
                           (let [node (first (.nodes @cy-instance selector))
                                 node-pos-fn (fn []
                                               (let [node (select-node selector)
                                                     bb (to-clj (.boundingBox node))
                                                     width (* 0.75 (:w bb))
                                                     height (* 0.80 (:h bb))
                                                     top (/ (- (:h bb) height) 2)
                                                     left (/ (- (:w bb) width) 2)
                                                     pos {:x (:x1 bb) :y (:y1 bb)}]
                                                 (swap! input-element-state merge
                                                   {:selector selector
                                                    :bg-color bg-color
                                                    :filter-atom filter-atom
                                                    :position {:x (+ left (:x pos))
                                                               :y (+ top (:y pos))}
                                                    :width width
                                                    :height height
                                                    :parent-node node}))
                                               (when-let [filter-text (get-input-text)]
                                                 (filter-and-render filter-atom node filter-text)))]
                             (reset! filter-input-node-fn node-pos-fn)
                             (node-pos-fn)))
        hide-filter-input #(swap! input-element-state assoc :display false)
        show-filter-input #(swap! input-element-state assoc :display true)
        filtered-nodes-visible-selector (atom nil)
        set-filtered-node-visible-selector (fn [old-selector new-selector]
                                             (if (= old-selector new-selector)
                                               nil
                                               new-selector))
        hide-filtered-nodes (fn [selector]
                              (let [filtered-nodes (.nodes @cy-instance selector)]
                                (doseq [node filtered-nodes]
                                  (.style node "display" "none"))))
        show-filtered-nodes (fn [selector]
                              (let [filtered-nodes (.nodes @cy-instance selector)]
                                (doseq [node filtered-nodes]
                                  (.style node "display" "element"))))

        set-filtered-nodes-visibility! (fn [& flip-atoms]
                                        (let [all-visibility-atoms #{filtered-members-visible filtered-roles-left-visible filtered-roles-right-visible}]
                                          (doseq [at flip-atoms]
                                            (swap! at not))
                                          (doseq [at (set/difference all-visibility-atoms (set flip-atoms))]
                                            (reset! at false))))

        filtered-selector-params {filtered-menu-members-selector {:color "#77C9B2"
                                                                  :hl-class "brightened-green"
                                                                  :sum-node-selector sum-members-selector
                                                                  :filtered-atom filtered-members}
                                  filtered-menu-roles-left-selector {:color "orange"
                                                                     :hl-class "brightened-orange"
                                                                     :sum-node-selector sum-roles-left-selector
                                                                     :filtered-atom filtered-roles-left}
                                  filtered-menu-roles-right-selector {:color "orange"
                                                                      :hl-class "brightened-orange"
                                                                      :sum-node-selector sum-roles-right-selector
                                                                      :filtered-atom filtered-roles-right}}

        _ (track! (fn []
                    (when @cy-instance
                      (hide-filter-input)
                      (doseq [selector [filtered-menu-roles-left-selector filtered-menu-roles-right-selector filtered-menu-members-selector]
                              :let [params (filtered-selector-params selector)
                                    sum-node (select-node (:sum-node-selector params))]]
                        (hide-filtered-nodes selector)
                        (when sum-node
                          (.removeClass sum-node (:hl-class params))
                          (.data sum-node "label" (str "View " (.data sum-node "aggregation_count") " " (.data sum-node "aggregation_label")))))
                      (when @filtered-nodes-visible-selector
                        (let [params (filtered-selector-params @filtered-nodes-visible-selector)
                              filter-parent-node (select-node @filtered-nodes-visible-selector)
                              sum-node (select-node (:sum-node-selector params))]
                          (show-filtered-nodes @filtered-nodes-visible-selector)
                          (render-down-items
                            filter-parent-node
                            (or (some-> (:filtered-atom params) deref) (.data filter-parent-node "items")))
                          (add-filter-input (:filtered-atom params) @filtered-nodes-visible-selector (:color params))
                          #_(adjust-container-height! @cy-instance)
                          (.addClass sum-node (:hl-class params))
                          (.data sum-node "label" (str "Hide " (.data sum-node "aggregation_count") " " (.data sum-node "aggregation_label")))
                          (show-filter-input))))))

        register-sum-node-tap (fn []
                                (.on @cy-instance "tap" sum-members-selector
                                  #(swap! filtered-nodes-visible-selector set-filtered-node-visible-selector filtered-menu-members-selector))
                                (.on @cy-instance "tap" sum-roles-right-selector
                                  #(swap! filtered-nodes-visible-selector set-filtered-node-visible-selector filtered-menu-roles-right-selector))
                                (.on @cy-instance "tap" sum-roles-left-selector
                                  #(swap! filtered-nodes-visible-selector set-filtered-node-visible-selector filtered-menu-roles-left-selector)))

        init-chart (fn [_ chart-data]
                     (when @cy-instance
                       (.destroy @cy-instance))
                     (reset! cy-instance (init-cy chart-data))
                     (register-tap-ev)
                     (render-items)
                     (dont-notify
                       #(adjust-initial-pan! @cy-instance))
                     (register-sum-node-tap)
                     (swap! input-element-state assoc :display false :filter-text nil))]

    (add-resize-listener (fn []
                           (hide-filter-input)
                           (reset! cy-instance (init-cy chart-data))
                           (register-tap-ev)
                           (render-items)
                           (dont-notify
                             #(adjust-initial-pan! @cy-instance))
                           (register-sum-node-tap)))

    (util/add-watch-new view-reset-atom :view-reset-watch
      (fn [_]
        (set! (.-height (.-style @element)) chart-base-height)
        (set-filtered-nodes-visibility!)
        (init-chart nil @last-chart-data)
        (.scrollTo js/window 0 0)))


    (reagent/create-class
      {:component-did-mount  (fn []
                              (init-chart nil chart-data)
                              (adjust-container-height! @cy-instance))

       :component-did-update (fn [this [_ old-chart-data]]
                               (let [new-chart-data (reagent/props this)]
                                 (when (not= old-chart-data new-chart-data)
                                   (reset! last-chart-data new-chart-data)
                                   (init-chart nil new-chart-data))))
       :component-will-unmount (fn []
                                 (remove-resize-listener)
                                 (when @cy-instance
                                   (.destroy @cy-instance)
                                   (reset! cy-instance nil)))
       :reagent-render (fn []
                         (let [subject-collection-id (-> @last-chart-data :collection :id)]
                           [:div.c-orgchart
                            [:div {:ref (fn [el]
                                          (when el
                                            (reset! element el)))
                                   :style {:width "100%" :height chart-base-height}}]
                            [left-node-controls
                             node-controls-options
                             subject-collection-id
                             (:node-data @node-controls-state)
                             (:display @node-controls-state)
                             (:left-position @node-controls-state)
                             {:width -1}]
                            [right-node-controls
                             node-controls-options
                             subject-collection-id
                             (:node-data @node-controls-state)
                             (:display @node-controls-state)
                             (:right-position @node-controls-state)
                             nil]
                            (when @cy-instance
                              [:input {:type :text
                                       :ref (fn [el]
                                              (when el
                                                (reset! input-element el)
                                                (when (:display @input-element-state)
                                                  (.focus el))))
                                       :style (let [pos (convert-position (:position @input-element-state))]
                                                {:visibility (if (and
                                                                   (:display @input-element-state)
                                                                   (>= (:x pos) -0)
                                                                   (>= (:y pos) -0)) "visible" "hidden")
                                                 :position "absolute"
                                                 :background-color (:bg-color @input-element-state)
                                                 :font-size (str (zoom-rescale 0.8) "em")
                                                 :width (str (zoom-rescale (:width @input-element-state)) "px")
                                                 :height (str (zoom-rescale (:height @input-element-state)) "px")
                                                 :left (:x pos)
                                                 :top (:y pos)})
                                       :on-change (fn [e]
                                                    (let [filter-text (.-value (.-target e))]
                                                      (swap! input-element-state update-input-text filter-text)
                                                      (filter-and-render
                                                        (:filter-atom @input-element-state)
                                                        (:parent-node @input-element-state) filter-text)))
                                       :value (get-input-text)}])]))})))

(defn- field-ref-type [field-ref] (if (string? field-ref)
                                    :string
                                    :address))
(defmulti get-refs field-ref-type)
(defmethod get-refs :string [ref _] [ref])

(defn address-refs [primary secondary] {:primary primary
                                        :secondary secondary})
(defn- address-field-value [field collection]
  (map #(coltype-model/get-value %1 collection) (:subfields field)))

(defmethod get-refs :address [ref ref-field-map collection]
  (filter
    #(contains? ref-field-map %1)
    (let [primary-ref (first (filter #(contains? ref-field-map %1) (:primary ref)))
          secondary-ref (first (filter #(contains? ref-field-map %1) (:secondary ref)))]
      (if (= (address-field-value (ref-field-map primary-ref) collection) (address-field-value (ref-field-map secondary-ref) collection))
      [primary-ref]
      [primary-ref secondary-ref]))))

(def chart-header-refs
  ;; * Company: Name, address, jurisdiction, formation date, EIN, tax classification
  ;; * Trust: Name, address, jurisdiction/governing law, EIN, tax filing type
  ;; * Individual: Name, address, DOB, SSN, tax filing type

  [;; individual
   "individual_name"

   ;; common
   "alternate_name"
   "trade_or_dba_name"

   ;; common
   (address-refs ["us_address" "physical_address" "home_address"] ["mailing_address"])
   "jurisdiction" "country_of_jurisdiction" "governing_law" "state_of_formation" "formation_date" "date_of_birth" "ssn"

   ;; individual
   "fincen_registration_id"

   ;; common
   "ein" "tax_id_type" "tax_id_no" "foreign_tin" "tax_classification"

   ;; grat
   "fixed_term_expiration_date"
   "final_annuity_payment_date"

   ;; married_couple
   "date_of_marriage"

   ;; revocable_trust, married_couple
   "tax_filing_type_with_other"])

(defn chart-header [{:keys [mount-cb]} collection collection-type-form-def chart-type]
  (with-let [expanded (atom false)]
    (when-let [form-def collection-type-form-def]
      (let [all-segment-fields (apply concat (map :fields (:forms form-def)))
            form-fields (filter-fields (coltype-model/flatten-fields all-segment-fields true) collection)
            ref-field-map (util/associate-by :ref form-fields)
            visible-field-refs (set (keys ref-field-map))
            header-refs (for [field-ref chart-header-refs
                              ref (get-refs field-ref ref-field-map collection)
                              :when (visible-field-refs ref)] ref)]
        [:div
         {:ref (fn [] (some-> mount-cb (apply [])))
          :style {:position :absolute}}
         [:div
          {:class (if @expanded "u-shadow--bottom-xs" "")
           :style {:position :relative
                   :top "-0.5em"
                   :left "-0.5em"
                   :z-index 1000
                   :background-color "rgba(241, 242, 242, 0.8)"
                   :padding "0.5em 0.5em 0.5em 0.5em"}}
          [:h2.o-collapsable.u-flex
           {:on-click (util/handler (fn[] (swap! expanded not)))
            :class (when-not @expanded "is-collapsed")
            :style {:cursor :pointer}}
           [:span.c-collection-chart-header (:name collection) " " chart-type]
           (when (seq header-refs)
             [:a.o-collapsable__expander
              {:style {:margin-left "0.5em"
                       :z-index 1000
                       :position :relative
                       :top "-0.1em"
                       :font-size "0.8em"
                       :cursor :pointer}}])]
          (when @expanded
            (doall
              (for [ref header-refs
                    :let [field (get ref-field-map ref)
                          field-type (keyword (:type field))
                          label (or
                                  (:details_label field)
                                  (not-empty (:label field)))]]
                [:div.u-font-size--smaller {:key ref}
                 (when (not-empty label)
                   [:b label ": "])
                 ^{:key ref} [(field-types field-type string-field)
                              {:address-field-style {:display :inline-block}}
                              (assoc field :details_spread_out false)
                              collection]])))]]))))

(def recent-key (clojure.core/atom nil))

(defn- history [_ collection]
  [:div.filter-item {:style {:display :inline-block
                             :margin-left "0.5em"}}
   [:div {:style {:font-size "0.5em"
                  :text-transform :none}} "History (View recent)"]
   [:select
    (merge
      {:on-change (fn [event]
                    (util/set-location
                      (path-for :collection-charts :id (util/event-value event))))}
      (when collection
        {:value (:id collection)}))

    (doall
      (for [item (reverse (util/uniq-by :id (@state/chart-recent @recent-key)))]
        [:option {:key (:id item) :value (:id item)} (:name item)]))]])

(defn- subject [_ _]
  (let [collections (subscribe :collection-list)]
    (fn [_ collection]
      [:div.filter-item {:style {:display :inline-block
                                 :margin-left "0.5em"}}
       [:div {:style {:font-size "0.5em"
                      :text-transform :none}} "Select Subject"]
       [:select
        (merge
          {:on-change (fn [event]
                        (util/set-location
                          (path-for :collection-charts :id (util/event-value event))))}
          (when collection
            {:value (:id collection)}))
        (doall
          (for [[collection-type collections] (util/ordered-group-by :collection_type (filter collection-model/can-be-chart-subject? @collections))]
            [:optgroup {:key (:id collection-type)
                        :label (coltype-model/collection-type-name collection-type)}
             (for [item collections] [:option {:key (:id item) :value (:id item)} (:name item)])]))]])))

(defn- show-inactive [options]
  (let [show-inactive? (:show-inactive? options)]
    (fn []
      [:div.filter-item {:style {:display :inline-block
                                 :margin-left "0.5em"}}
       [:div {:style {:font-size "0.5em"
                      :text-transform :none}} "Show Inactive Collections"]
       [:input (form/set-checked
                @show-inactive?
                {:type "checkbox"
                 :on-change (fn [_] (swap! show-inactive? not))})]])))

(defn org-chart [collection-id]
  (with-let [chart-data (subscribe :chart)
             collection (track! #(:collection @chart-data))
             form-def (atom nil)
             chart-header-rendered (atom false)
             view-modified (atom false)
             notify-modified! #(reset! view-modified true)
             view-reset (atom false)
             show-inactive? (atom false)
             load-chart-data (fn [collection-id show-inactive?]
                               (controller/dispatch :chart
                                                    :load {:collection-id collection-id 
                                                           :show-inactive show-inactive?}))
             update-family-overlay-path (fn [collection-id]
                                       (->>
                                        (p/all [(collection-model/collection-ancestors collection-id)])
                                        (p/map (fn [[ancestors-response]]
                                                 (reset! state/recent-parent-ids (concat [nil] (mapv #(:id %) (filterv :has_any_permission ancestors-response))))))
                                        (process-error)))
             _ (do
                 (controller/dispatch :chart :clear)
                 (controller/dispatch :collection-list :clear)
                 (when-not @recent-key
                   (reset! recent-key
                           (if-let [rkey-b64 (:rkey (util/get-location-params))]
                             (util/base64-url-unmarshal rkey-b64)
                             (uuid/uuid-string (uuid/make-random-uuid)))))
                 (add-watch collection :collection-history
                            (fn [_ _ oldv newv]
                              (when (and newv (not= oldv newv))
                                (swap! state/chart-recent update @recent-key
                                       (fn [recent]
                                         (reverse
                                          (util/uniq-by :id
                                                        (conj (reverse (or recent [])) (select-keys newv [:id :name])))))))))
                 (add-watch collection :collection-form-def
                            (fn [_ _ oldv newv]
                              (when (and newv (not= (:collection_type_id oldv) (:collection_type_id newv)))
                                (->> (coltype-model/collection-type-form-def (:collection_type_id newv))
                                     (p/map #(reset! form-def %))
                                     (process-error)))))
                 (util/add-watch-new collection :subject-collection-list
                                     (fn [new-subject-collection]
                                       (when new-subject-collection
                                         (do
                                           (controller/dispatch :collection-list :load {:parent-id (-> new-subject-collection :family :id)
                                                                                        :include-intermediate true})
                                           (update-family-overlay-path (:id new-subject-collection))))))
                 (add-watch show-inactive? :show-inactive
                            (fn [_ _ oldv newv]
                              (load-chart-data collection-id @show-inactive?)))
                 (load-chart-data collection-id @show-inactive?)                 
                 (util/set-location-params {"rkey" (util/base64-url-marshal @recent-key)}))]
    [:div
     [:div.u-floating {:style {:display :inline-block
                               :margin-left "calc(100% - 6em)"
                               :overflow :hidden
                               :padding-top "1.6em"
                               :z-index 1}}
      [:button.c-button--small (merge
                                 {:style {:margin-right "1em"
                                          :display :inline-block}
                                  :on-click (util/handler
                                              (fn []
                                                (reset! view-modified false)
                                                (swap! view-reset not)))}
                                 (when-not @view-modified
                                   {:disabled :disabled})) "Reset view"]]
     [common/header-tab-wrapper-with-options {:style {:position "relative" :top "-3.3em"
                                                      }
                                              :header-style {:padding-bottom "0.5em"
                                                             :padding-top "0.8em"}}

      [:div.c-collection-chart-header
       [:span (get-in @collection [:family :name])]
       [history nil @collection]
       [subject nil @collection]
       [show-inactive {:show-inactive? show-inactive?}]]
      [:div
       [:div.o-media.o-flex-align--space-between.u-padding-top
        (when (and @collection @form-def)
          [chart-header {:mount-cb (fn [] (reset! chart-header-rendered true))} @collection @form-def (chart-type (:chart_type @chart-data))])]
       ;; Presentation of the chart is delayed until the header is rendered
       ;; Otherwise cytoscape gets confused about coordinates
       (when @chart-header-rendered [cytoscape-component @chart-data notify-modified! view-reset])]]]
    (finally
      (remove-watch collection :collection-form-def)
      (remove-watch collection :subject-collection-list))))
